import {
  PHP_TO_REACT_SHORTCUT_COMMANDS,
  PHP_TO_REACT_SHORTCUT_NAMESPACES,
  REACT_TO_PHP_SHORTCUT_COMMANDS,
  SHORTCUT_COMMAND_ERRORS,
} from "./shortcut-command-constants";
import type { ShortcutCommandResult } from "./shortcut-command-types";

function createStringSetGuard<T extends string>(values: readonly T[]) {
  const set = new Set<string>(values);
  return (value: unknown): value is T =>
    typeof value === "string" && set.has(value);
}

const shortcutCommandErrors = new Set<string>(SHORTCUT_COMMAND_ERRORS);

export const isPhpToReactShortcutCommand = createStringSetGuard(
  PHP_TO_REACT_SHORTCUT_COMMANDS,
);

export const isReactToPhpShortcutCommand = createStringSetGuard(
  REACT_TO_PHP_SHORTCUT_COMMANDS,
);

export const isPhpToReactShortcutNamespace = createStringSetGuard(
  PHP_TO_REACT_SHORTCUT_NAMESPACES,
);

export function isShortcutCommandResult(
  value: unknown,
): value is ShortcutCommandResult {
  if (typeof value !== "object" || value === null || !("success" in value)) {
    return false;
  }

  if (value.success === true) {
    return true;
  }

  return (
    value.success === false &&
    "error" in value &&
    typeof value.error === "string" &&
    shortcutCommandErrors.has(value.error)
  );
}
